import React from "react";

export default function Footer(props) {
    return (
        <div className="footer">
            <section className="footer-wrapper">&copy; 2022 CASA SEAT | Paseo de Gracia 109, Barcelona | De 9h a 21h. De lunes a sábado <br></br> </section>
        </div>
    );
}
